// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Layers as RawLayers } from "lucide-react";
export const Layers = /* @__PURE__ */ createIcon(RawLayers, "Layers", 2);
